import validate from "/home/denis/sources/sos-amiante/client/node_modules/nuxt/dist/pages/runtime/validate.js";
import auth_45global from "/home/denis/sources/sos-amiante/client/middleware/auth.global.ts";
import manifest_45route_45rule from "/home/denis/sources/sos-amiante/client/node_modules/nuxt/dist/app/middleware/manifest-route-rule.js";
export const globalMiddleware = [
  validate,
  auth_45global,
  manifest_45route_45rule
]
export const namedMiddleware = {}